import React, { memo, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import moment from 'moment';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import { ErrorBoundary } from "@appsignal/react";
import { Loader } from '@brandandcelebrities/kolkit';

import { history } from 'store/configureStore';
import routes from 'config/routes';
import { Locale } from 'locales';

import ScrollToTop from 'components/ScrollToTop';
import { useDispatch, useSelector } from 'utils/redux';
import useTranslations from 'utils/hooks/useTranslations';

import { changeLocale } from 'actions/env';
import { appsignal } from "config/appsignal";
import { UserState } from 'reducers/user';

import KolLandingPage from './KolLandingPage';

// TODO (Hoby): remove when executed from kolkit
import 'react-dates/initialize';

// libs CSS
import 'react-tippy/dist/tippy.css';
import 'react-toastify/dist/ReactToastify.min.css';
import '@brandandcelebrities/kolkitten/scss/checkboxes.scss';
import '@brandandcelebrities/kolkitten/scss/button.scss';
import 'react-dates/lib/css/_datepicker.css'; // TODO: same as above

import './App.scss';

interface Selector {
  locale: Locale;
  user: UserState;
}

const langueNavigateur = navigator.language || navigator.userLanguage;

const EXTERNAL_REDIRECT_URL = 'https://app.kreators.community/?community=true';

// Component to handle external redirects
const ExternalRedirect: React.FC<{ to: string }> = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return <Loader fullScreen />;
};

const App = () => {
  const { messages } = useTranslations();

  const { locale, user } = useSelector(
    ({ env, user }): Selector => ({
      locale: env.locale,
      user,
    }),
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(changeLocale(langueNavigateur.split('-')[0] === 'fr' ? 'fr' : 'en'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    moment.locale(locale.substr(0, 2));
  }, [locale]);

  return (
    <IntlProvider
      messages={messages}
      locale={locale.slice(0, 2)}
      defaultLocale="en"
      onError={(error) => messages ? console.warn(error) : null}
    >
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <ErrorBoundary
            instance={appsignal}
            tags={{
              id: user.userId,
              name: `${user.firstName}  ${user.lastName}`,
              currentUrl: window.location.href,
            }}
          >
          <div className="App">
            <Switch>
              <Route exact path={`${routes.kolLanding}/:token`} component={KolLandingPage} />
              <Route path="*" render={() => <ExternalRedirect to={EXTERNAL_REDIRECT_URL} />} />
            </Switch>
          </div>
          </ErrorBoundary>
        </ScrollToTop>
      </ConnectedRouter>
    </IntlProvider>
  );
};

export default memo(App);
